/* tslint:disable:jsx-no-lambda WI:47750 */
import * as React from 'react';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import RemoveRecipientButton from './RemoveRecipientButton';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import removeRecipientsAndLogMailTipsDatapoint from '../utils/removeRecipientsAndLogMailTipsDatapoint';
import { MailTipsCategory, MailTipsType } from '../datapoints';

export interface MultiRecipientDetailsProps {
    colorScheme?: ColorScheme;
    recipientEmails: EmailAddressWrapper[];
    onRemove: (recipients: EmailAddressWrapper[]) => void;
    mailTipsCategory?: MailTipsCategory;
}

const MultiRecipientDetails = (props: MultiRecipientDetailsProps) => {
    return (
        <div>
            {props.recipientEmails.map(recipientEmail => (
                <div key={recipientEmail.EmailAddress}>
                    <span>{recipientEmail.Name}</span>
                    <RemoveRecipientButton
                        colorScheme={props.colorScheme}
                        onClick={(recipient: EmailAddressWrapper) =>
                            removeRecipientsAndLogMailTipsDatapoint(
                                props.onRemove,
                                [recipient],
                                props.mailTipsCategory,
                                MailTipsType.SingleRecipient,
                                1
                            )
                        }
                        recipient={recipientEmail}
                    />
                </div>
            ))}
        </div>
    );
};

export default MultiRecipientDetails;
